export const types = {
    authLogin: 'authLogin',
    authCheckingFinish: 'authCheckingFinish',
    authLogout: 'authLogout',

    taskAdd: 'taskAdd',
    taskRemove: 'taskRemove',
    taskUpdate: 'taskUpdate',
    taskToggle: 'taskToggle',
    taskActive: 'taskActive',
    taskLoad: 'taskLoad',
    // taskToggleAll: 'taskToggleAll',
    // taskClearCompleted: 'taskClearCompleted',
    // taskFilter: 'taskFilter',
    // taskFilterClear: 'taskFilterClear',
}